// Shared gradient-overlay helper for image "scrim" effects (Advert module
// background image, Tiptap rich-text images) — a dark/colour wash fading
// from transparent to a chosen colour, commonly used so overlaid text stays
// legible over a photo.
export const GRADIENT_DIRECTIONS = [
  { value: "none", label: "None" },
  { value: "to-bottom", label: "Top \u2192 Bottom" },
  { value: "to-top", label: "Bottom \u2192 Top" },
  { value: "to-right", label: "Left \u2192 Right" },
  { value: "to-left", label: "Right \u2192 Left" },
  { value: "radial", label: "Radial (edges)" },
];

function hexToRgba(hex, alpha) {
  const clean = (hex || "#000000").replace("#", "");
  const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
  const r = parseInt(full.slice(0, 2), 16) || 0;
  const g = parseInt(full.slice(2, 4), 16) || 0;
  const b = parseInt(full.slice(4, 6), 16) || 0;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// direction: one of GRADIENT_DIRECTIONS values. color: hex. opacityPct: 0-100.
export function buildGradientCss(direction, color, opacityPct) {
  if (!direction || direction === "none") return null;
  const alpha = (opacityPct ?? 60) / 100;
  const solid = hexToRgba(color, alpha);
  if (direction === "radial") {
    return `radial-gradient(circle, transparent 0%, ${solid} 100%)`;
  }
  const cssDirection = direction.replace("-", " ");
  return `linear-gradient(${cssDirection}, transparent 0%, ${solid} 100%)`;
}
